import React from 'react'
import {
  Switch,
  FormControlLabel,
  SwitchProps,
  FormControlLabelProps,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import omit from 'lodash/omit'

import { useAppSelector } from 'redux/Hook'
import type { Dispatch } from 'redux'

interface LabelledSwitchProps {
  id: string
  label: string
  switchProps?: SwitchProps
  formControlLabelProps?: FormControlLabelProps
  onChange: (name: string, value: boolean, dispatch: Dispatch) => void
}
const LabelledSwitch: React.FC<LabelledSwitchProps> = (props) => {
  const { label, onChange, switchProps, formControlLabelProps, id, ...rest } =
    props
  const toolState = useAppSelector(
    (state) => state.toolBuilder.toolBuilder,
  ) as Record<string, any>
  const value = toolState[id || label] || false
  const dispatch = useDispatch()
  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  return (
    <FormControlLabel
      control={<Switch {...switchProps} checked={value} />}
      label={label}
      {...formControlLabelProps}
      {...omit(rest, ['helperText', 'error'])}
      disabled={fetching || saving}
      onChange={(_, checked: boolean) => {
        return onChange(id, checked, dispatch)
      }}
    />
  )
}

export default LabelledSwitch
export type { LabelledSwitchProps }
